export default {
  title: "45.500 Yıllık Mağara Resmi",
  text: `Endonezya’daki bir mağaranın duvarında keşfedilen bir resmin en az 45.500 yıl önce yapıldığı tespit edildi. Mağara resmi, bilinen en eski figüratif sanat eseri unvanını ele geçirdi.



  Endonezya’ya bağlı Sulawesi Adası çok sayıda mağara resmine ev sahipliği yapıyor. Bölgede ilk araştırmaların başlamasından bu yana geçen 70 yılda duvarlarında resimler bulunan 300’den fazla mağara keşfedildi. Daha önceleri bilinen en eski figüratif sanat eseri unvanının sahibi olan, bir av sahnesinin betimlendiği mağara resmi de yine bu bölgede yer alıyordu. Geçtiğimiz yıl yapılan çalışmalar, bu mağara resminin 43.900 yaşında olduğunu göstermişti.
  Basran Burhan tarafından yeni keşfedilen mağara resminin en az 45.500 yıllık olduğu belirtiliyor. Orta bölgeleri tahrip olmuş resmin sol tarafında bir Sulawesi yaban domuzu ve insan elleri, sağ tarafındaysa muhtemelen dövüşmekte olan iki Sulawesi yaban domuzu görülüyor.
  Araştırma ekibinin üyelerinden Maxime Aubert, 45.500’ün, keşfedilen mağara resminin yaşı için bir alt sınır olduğunu vurguluyor. Bölgede 60.000-65.000 yaşında mağara resimleri bile olabileceği söyleniyor. 
  `
};



// WEBPACK FOOTER //
// ./src/assets/goz-ritim/lise/12.js